<div class="modal-header">
    <h3 class="modal-title" id="modal-title-id">{{LOCALIZATION.saveSearch}}</h3>
</div>
<div class="modal-body" style="max-height: 82vh; overflow-y: auto;">
    <form #kvForm="ngForm" name="kvForm" class="form-signin" style="max-width:400px">
        <div class="row">
            <div class="well col-md-12">
                <div class="truncate">{{LOCALIZATION.query}}: <span title="{{searchObj.query}}">{{searchObj.query}}</span></div>
                <div class="truncate">Type: <span title="{{searchObj.type}}">{{searchObj.type}}</span></div>
                <div *ngIf="searchObj.aoi" class="truncate">{{LOCALIZATION.boundTo}}: <span title="{{searchObj.aoi}}">{{searchObj.aoi}}</span></div>
                <div *ngFor='let value of Object.values(searchObj.criteria)' class="truncate">
                    {{value.display_header}}: <span title="{{value.display_value}}">{{value.display_value}}</span>
                </div>
                <div>{{LOCALIZATION.libraries}}: <span title="{{libraries}}">{{libraries}}</span></div>
                <div *ngIf="input.userName">{{LOCALIZATION.creator}}: <span title="{{input.userName}}">{{input.userName}}</span></div>
            </div>
        </div>
        <div class="row">
            <div class="col-md-12">
                <div class="row">
                    <label for="searchname">{{LOCALIZATION.name}}</label>
                    <input type="text" maxlength="{{limits.searchname}}"
                    	[(ngModel)]='input.searchname'
                    	id="searchname" name="searchname"
                    	[disabled]="mode == 'view'" 
                    	class="form-control" placeholder="Search Name" required />
                    <span class="help-block pull-right">{{input.searchname.length||0}}/{{limits.searchname}}</span>
					<span *ngIf="kvForm.form.controls['searchname']?.invalid && kvForm.form.controls['searchname']?.touched" class="required">
					  {{LOCALIZATION.required}}
					</span>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-md-12">
                <div class="row">
                    <label for="searchDesc">{{LOCALIZATION.description}}</label>
					<textarea [(ngModel)]='input.description'
					    id="description" name="description"
					    [disabled]="mode == 'view'"
						maxlength="{{limits.description}}" cols="120"
						placeholder="{{LOCALIZATION.searchDescriptionPlaceholder}}"
						class="form-control" 
						style="margin:0px; max-width:99%; height:320px; border:1px solid #9e9e9e;"
						aria-label="Description"></textarea>                	
	                    <span class="help-block pull-right">{{input.description.length||0}}/{{limits.description}}</span>                    
                </div>
            </div>
        </div>
        <div class="row" *ngIf="userPermissions['ROLE_PUBLISH_SAVED_SEARCH']">
            <div class="col-md-12">
                <div class="row">
                    <label for="saveSearchVisibility">{{LOCALIZATION.public}}</label>
                    <div class="toggle-switch">
                        <input type="checkbox" 
                        	[(ngModel)]="input.searchpublic"
                        	id="toggle" name="toggle"
                        	[disabled]="mode == 'view'" 
                        	class="toggle-switch-toggle toggle-switch-toggle-round" [ngClass]="{'disabled' : mode == 'view'}"/>
                        <label for="toggle"></label>
                    </div>
                </div>
            </div>
        </div>                
        <div class="row" *ngIf="input.notificationSubscriberPrefs" style="margin-top: 15px;">
            <div class="well col-md-12" *ngIf="input.notificationSubscriberPrefs">
            	<div class="col-md-6">
            		<h4>{{LOCALIZATION.notificationProperties}}</h4>
            	</div>
                <div class="col-md-6" *ngIf="(userPermissions['ROLE_USERS_EMAIL'])">
                    <label for="subscriberEmail">{{LOCALIZATION.email}}</label>
                    <div class="toggle-switch">
                        <input type="checkbox"
                        	[(ngModel)]="input.subscriberEmail"
                        	id="email-toggle" name="email-toggle" 
                        	class="toggle-switch-toggle toggle-switch-toggle-round">
                        <label for="email-toggle"></label>
                    </div>
                </div>
                <div class="col-md-6">
                    <label for="subscriberNotification">{{LOCALIZATION.message}}</label>
                    <div class="toggle-switch">
                        <input type="checkbox"
                        	[(ngModel)]="input.subscriberNotification"
                        	id="notification-toggle" name="notification-toggle"
                        	class="toggle-switch-toggle toggle-switch-toggle-round">
                        <label for="notification-toggle"></label>
                    </div>
                </div>
                <label for="subscriberDuration">{{LOCALIZATION.duration}}</label>
                <input type="text" 
                	[(ngModel)]='input.subscriberDuration' 
                	id="subscriberDuration" name="subscriberDuration"
                	class="form-control" placeholder="Subscription duration" required>
            </div>
        </div>
    </form>
</div>
<div class="modal-footer">
	<button class="btn btn-default" type="button" (click)="close()">{{LOCALIZATION.cancel}}</button>
    <button type="button"
    	*ngIf="mode == 'add'" class="btn btn-primary" 
    	[disabled]="!kvForm.valid" (click)="save()">{{LOCALIZATION.save}}</button>
    <button type="button"
    	*ngIf="mode == 'update' || input.notificationSubscriberPrefs"
    	class="btn btn-primary"  
    	[disabled]="!kvForm.valid" (click)="save()">{{LOCALIZATION.update}}</button>
</div>
